<template>
  <v-card flat>
    <v-card-text>
      <v-container  grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn color="info" @click="addNewAdditionalDay" v-if="$can('do','POKO_Terapeuci_Edycja')" style="float:right">Dodaj dodatkowy dzień otwarty</v-btn>
          </v-flex>
          <v-flex xs12>
            <v-data-table
                :headers="headers"
                :options.sync="pagination"
                :items="items"
                :loading="loading"
                :server-items-length="totalResults"
                :no-results-text="'Nie znaleziono wierszy'"
                :footer-props="{itemsPerPageOptions:[20,50,100,200]}"
                :no-data-text="'Brak danych'"
            >
              <template v-slot:item.timeStart="{item}">
                {{ getTimeFormatted(item.timeStart) }}
              </template>
              <template v-slot:item.timeEnd="{item}">
                {{ getTimeFormatted(item.timeEnd) }}
              </template>
              <template v-slot:item.start="{item}">
                {{ getDateFormatted(item.start) }}
              </template>
              <template v-slot:item.end="{item}">
                {{ getDateFormatted(item.end) }}
              </template>
              <template v-slot:item.id="{item}">
                <v-layout align-center>
                  <v-icon small class="mr-2" @click="editAdditionalOpenDay(item.id)" v-if="$can('do','POKO_Terapeuci_Edycja')" title="Edytuj">fa-edit</v-icon>
                  <v-icon small @click="deleteAdditionalDay(item.id)" itle="Usuń" v-if="$can('do','POKO_Terapeuci_Edycja')">fa-trash-alt</v-icon>
                </v-layout>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12>
              <AddEditAdditionalDay :visible="showAddEditAdditionalDay" v-if="showAddEditAdditionalDay" @close="closingEditor" :therapistID="therapistID" :openDayData="openDayData"></AddEditAdditionalDay>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { therapistsService } from "@/services/";
import * as dayjs from "dayjs";
import {mapActions} from "vuex";
import swal from "sweetalert";
import AddEditAdditionalDay from "@/components/therapists/AddEditAdditionalDay.vue";
export default {
  name: "AdditionalOpenDays",
  components: {AddEditAdditionalDay},
  data() {
    return {
      loading: false,
      showAddEditAdditionalDay: false,
      totalResults: 0,
      items: [],
      pagination: {},
      openDayData: {
        id: 0,
        start: '',
        end: '',
        timeStart: '',
        timeEnd: ''
      },
      headers: [
        { text: 'Data start', sortable: true, align: 'left', value: 'start'},
        { text: 'Data koniec', sortable: true, align: 'left', value: 'end'},
        { text: 'Godzina start', sortable: true, align: 'left', value: 'timeStart'},
        { text: 'Godzina koniec', sortable: true, align: 'left', value: 'timeEnd'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
    }
  },
  props: {
    therapistID: Number
  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
    deleteAdditionalDay(id) {
      swal({
        title: "Czy na pewno?",
        text:
            "Czy na pewno chcesz usunąć wybrany dodatkowy dzień?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          therapistsService
              .DeleteAdditionalOpenDay(id)
              .then(resp => {
                if (resp.data == null || !resp.data.success) {
                  throw "Błąd usuwania dodatkowego dnia";
                } else {
                  this.success("Usunięto");
                  this.refreshTable()
                }
              })
              .catch(()=> {
                this.error("Nie można usunąć dodatkowego dnia");
              });
        }
      });
    },
    editAdditionalOpenDay(id)  {
      let item = this.items.find(x=>x.id == id)
      if(item != null) {
        this.openDayData = {
          id: item.id,
          start: dayjs(item.start).format('YYYY-MM-DD'),
          end: dayjs(item.end).format('YYYY-MM-DD'),
          timeStart: item.timeStart,
          timeEnd: item.timeEnd
        }
        this.showAddEditAdditionalDay = true
      }
    },
    addNewAdditionalDay() {
      this.openDayData = {
        id: 0,
        start: '',
        end: '',
        timeStart: '',
        timeEnd: ''
      }
      this.showAddEditAdditionalDay = true
    },
    closingEditor() {
      this.showAddEditAdditionalDay = false
      this.refreshTable()
    },
    getDateFormatted(date)
    {
      if(date) {
        var dj = dayjs(date)
        return dj.format("DD/MM/YYYY")
      }
      else
      {
        return ''
      }
    },
    getTimeFormatted(date)
    {
      if(date) {
        var dj = dayjs(date,'HH:mm:ss')
        return dj.format("HH:mm")
      }
      else
      {
        return ''
      }
    },
    refreshTable()
    {
      this.loading = true

      this.requestAdditionalDays().then(data=> {
        this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
        this.loading = false
      })
    },
    requestAdditionalDays() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;

      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }

      var req = therapistsService.GetAdditionalOpenDays({ query: '', page: page, limit: itemsPerPage, therapistid: this.therapistID, sorting: sortValue });
      return req.catch(() => {
        this.showError(false,"Błąd pobierania dodatkowych dni");
      });
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
  },
  watch: {
    pagination: {
      handler() {
        if(this.therapistID) {
          this.refreshTable()
        }
      },
      deep: true
    },
    therapistID: {
      immediate: true,
      handler() {
        if(this.therapistID && this.pagination.page) {
          this.refreshTable()
        }
      }
    }
  },
}
</script>

<style scoped>

</style>